import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { RecentPurchase } from './RecentPurchase';

import { Order } from 'common/api/e-comm/models/Order';
import { getOrdersV2 } from 'common/api/e-comm/orders/service';
import { useApi } from 'common/modules/async-actions/useApi';

interface PurchasesProps {
    orders: Order[];
    loading: boolean;
}

const Purchases = ({ orders, loading }: PurchasesProps) => {
    if (loading) {
        return <Skeleton className="w-full h-full" />;
    }

    // NOTE: We only show the last 3 orders
    const recentOrders = orders.slice(0, 3);

    return (
        <div>
            {recentOrders.map((order: Order) => (
                <div key={order.orderNumber} className="mb-5">
                    <RecentPurchase order={order} />
                </div>
            ))}
        </div>
    );
};

const NUMBER_OF_MONTHS_TO_LOOK_BACK = 3;
const RecentPurchases = () => {
    const [fetchOrders, { loading }, orders] = useApi(getOrdersV2);
    const today = new Date();
    today.setMonth(today.getMonth() - NUMBER_OF_MONTHS_TO_LOOK_BACK);

    useEffect(() => {
        // NOTE: we'll want to cache this in the context
        fetchOrders(today.toISOString().split('T')[0]);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <p className="parti_dash_recent_purchase text-brand-dark font-semibold text-lg mb-2.5">
                Recent Purchases
            </p>
            <Purchases loading={loading} orders={orders?.data ?? []} />
        </div>
    );
};

export default RecentPurchases;
